import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames/bind';
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var PageFixer = function PageFixer(_ref) {
  var children = _ref.children,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'main' : _ref$backgroundColor,
    backgroundCustomColor = _ref.backgroundCustomColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$space = _ref.space,
    space = _ref$space === void 0 ? 0 : _ref$space,
    blockSpacersPreset = _ref.blockSpacersPreset,
    _ref$innerVerticalSpa = _ref.innerVerticalSpace,
    innerVerticalSpace = _ref$innerVerticalSpa === void 0 ? 0 : _ref$innerVerticalSpa;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrap', "wrap--bg-".concat(backgroundColor), "wrap--space-".concat(space), "wrap--inner-vertical-space-".concat(innerVerticalSpace), _defineProperty({}, "wrap--space-".concat(blockSpacersPreset), !!blockSpacersPreset)),
    style: {
      backgroundColor: backgroundCustomColor
    },
    "data-t-id": "PageBlocks-PageFixer"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('content', "content--".concat(size))
  }, children));
};
export { PageFixer };